/// #if PLATFORM === 'xd'
<template>
  <div class="assetPills my-2">
    <a
      v-for="(asset, index) in assets"
      :key="index"
      :class="['pill', asset === value ? 'active' : null]"
      href="#"
      @click.prevent="changeAsset(asset)"
    >{{ $tc(`items.${asset}.name`, 2) }}</a>
  </div>
</template>
/// #else
<template>
  <Pills>
    <button
      v-for="(asset, index) in assets"
      :key="index"
      :style="{ width: '33.33%' }"
      :class="{ active: asset === value }"
      type="button"
      @click.prevent="changeAsset(asset)"
    >{{ $tc(`items.${asset}.name`, 2) }}</button>
  </Pills>
</template>
/// #endif

<script>
import Platform from '@/plugin-platforms'
import { Assets } from '@/constants'
import Pills from './ui/Pills'

export default {
  components: {
    Pills
  },

  props: {
    value: {
      type: String,
      default: 'icon'
    }
  },

  computed: {
    // eslint-disable-next-line
/// #if PLATFORM === 'xd'
    localValue: {
      get () {
        return this.value
      },
      set () {
        this.changeAsset(this.$refs.selectAsset.value)
      }
    },
    isWindows () {
      const platform = require('os').platform()
      return platform.match(/^win(.)*/) !== null || false
    },
    // eslint-disable-next-line
/// #endif
    assets () {
      // In case of App don't show assets
      return Platform.platform.indexOf('desktop') > -1 ? [] : Assets
    }
  },

  methods: {
    changeAsset (asset) {
      this.$emit('input', asset)
      this.$store.commit('settings/setAsset', asset)
    }
  }
}
</script>
